import {Lotties} from "./Lotties";
import * as failResult
    from "../../../../assets/themes/vastbank/lotties/fail.json";
import * as pendingResult from "../../../../assets/themes/vastbank/lotties/pending.json";
import * as successTick from "../../../../assets/themes/vastbank/lotties/tick.json";
import * as processingID from "../../../../assets/themes/vastbank/lotties/pending.json";
import * as processingSelfie from "../../../../assets/themes/vastbank/lotties/pending.json";
import * as reviewResult
    from "../../../../assets/themes/vastbank/lotties/review.json";
import * as passResult
    from "../../../../assets/themes/vastbank/lotties/tick.json";

export const VastBankLotties: Lotties = {
    fail: failResult,
    pending: pendingResult,
    processComplete: successTick,
    processingId: processingID,
    processing: processingID,
    processingSelfie: processingSelfie,
    review: reviewResult,
    success: passResult,
    error: failResult
}